import { IAnalyticsEventGroup, IAnalyticsGroupArgument } from './types';
import { getGroupEventProperties } from './utils';

export const groupCreated = (
  role: IAnalyticsGroupArgument,
): IAnalyticsEventGroup => {
  return {
    eventName: 'Group Created',
    ...getGroupEventProperties(role),
  };
};

export const groupUpdated = (
  role: IAnalyticsGroupArgument,
): IAnalyticsEventGroup => {
  return {
    eventName: 'Group Updated',
    ...getGroupEventProperties(role),
  };
};
